import util from './shared/util.js';
import config from '../config.js';

var servicesURL = `${config.server.url}:${config.server.webServicesPort}/item/`;

class cdoItem {
    consumptionProfile = (idEntity, callback) => {
        util.getJSON(`${servicesURL}consumption-profile?idEntity=${encodeURIComponent(idEntity)}`, callback);
    }

    saveConsumptionProfile = (data, callback) => {
        util.putJSON(servicesURL + 'consumption-profile', data, callback);
    }
    create = (data, callback) => {
        util.putJSON(servicesURL + 'create', data, callback);
    }

    update = (data, callback) => {
        util.putJSON(servicesURL + 'update', data, callback);
    }

    duplicate = (data, callback) => {
        util.putJSON(servicesURL + 'duplicate', data, callback);
    }

    delete = (data, callback) => {
        util.putJSON(servicesURL + 'delete', data, callback);
    }

    selectAll = (callback) => {
        util.getJSON(`${servicesURL}select-all`, callback);
    }

    select = (idEntity, callback) => {
        util.getJSON(`${servicesURL}select?idEntity=${encodeURIComponent(idEntity)}`, callback);
    }

    selectMetadata = (callback) => {
        util.getJSON(`${servicesURL}metadata`, callback);
    }
}

const cdo = new cdoItem();
export default cdo;
